import styled from "@emotion/styled";
import {ButtonLink} from "./ButtonLink";

export const CTAButton = styled(ButtonLink)`
  font-size: 24px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  width: 300px;
`;
